/*
 * Fallback Screens
 */

const screens = function(params) {
  return {
    data: function() {
      return {
        baseForm: [
          {
            textArea: {
              title: this.$t('WIDGETS.TEXT_AREA.TITLE'),
              placeHolder: this.$t('WIDGETS.TEXT_AREA.PLACEHOLDER'),
            },
          },
          {
            button: {
              'border-color': '#24C48B',
              style: 'button',
              'background-color': '#24C48B',
              'font-color': '#ffffff',
              text: this.$t('WIDGETS.BUTTON.SEND'),
              action: {
                type: 'createTicket',
                data: {
                  order_id: 555267453,
                  store_type: 'express',
                  city_id: 1,
                  action_string:
                    '{"order_id":0,"store_type":"express","city_id":1}',
                },
              },
              percentage: 6,
            },
          },
        ],
      }
    },
    methods: {
      getScreen(screenName) {
        return this[screenName]
      },
    },
  }
}

export default screens
